// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"tabs_tabsContainer__t2LFo","tab":"tabs_tab__Ijc5r"};